import React, { useReducer } from "react";
import { v4 as uuidv4 } from "uuid";
import AlertContext from "./AlertContext";
import AlertReducer from "./AlertReducer";
import { SET_ALERT, REMOVE_ALERT, CLEAR_ALERTS, RESET_ALERT } from "../types";

const AlertState = (props) => {
  const initialState = [];

  const [state, dispatch] = useReducer(AlertReducer, initialState);

  //Reset Context State
  const resetAlertState = () => {
    dispatch({
      type: RESET_ALERT,
      payload: { ...initialState },
    });
  };

  //Set Alert
  const setAlert = (msg, type) => {
    const id = uuidv4();
    dispatch({
      type: SET_ALERT,
      payload: { msg, type, id },
    });
  };

  //Set Alert
  const setAlertTarget = (msg, type, target) => {
    const id = uuidv4();
    console.log("Alert state", msg, type, id, target);
    dispatch({
      type: SET_ALERT,
      payload: { msg, type, id, target },
    });
  };

  //Remove Alert
  const removeAlert = (id) => {
    dispatch({
      type: REMOVE_ALERT,
      payload: id,
    });
  };

  //Clear Alerts
  const clearAlerts = () => {
    console.log("ALert Clear");
    dispatch({
      type: CLEAR_ALERTS,
    });
  };

  return (
    <AlertContext.Provider
      value={{
        alerts: state,
        setAlert,
        setAlertTarget,
        removeAlert,
        clearAlerts,
        resetAlertState,
      }}
    >
      {props.children}
    </AlertContext.Provider>
  );
};

export default AlertState;
